// extracted by mini-css-extract-plugin
module.exports = {"Empty":"Empty--1zHb2","Text":"Text--2G5mg"};